import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './product-offering-price.reducer';

export const ProductOfferingPriceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const productOfferingPriceEntity = useAppSelector(state => state.productOfferingPrice.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="productOfferingPriceDetailsHeading">
          <Translate contentKey="crawlerBackendApp.productOfferingPrice.detail.title">ProductOfferingPrice</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{productOfferingPriceEntity.id}</dd>
          <dt>
            <span id="effectiveDate">
              <Translate contentKey="crawlerBackendApp.productOfferingPrice.effectiveDate">Effective Date</Translate>
            </span>
          </dt>
          <dd>
            {productOfferingPriceEntity.effectiveDate ? (
              <TextFormat value={productOfferingPriceEntity.effectiveDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="expirationDate">
              <Translate contentKey="crawlerBackendApp.productOfferingPrice.expirationDate">Expiration Date</Translate>
            </span>
          </dt>
          <dd>
            {productOfferingPriceEntity.expirationDate ? (
              <TextFormat
                value={productOfferingPriceEntity.expirationDate}
                type="date"
                format={APP_LOCAL_DATE_FORMAT}
              />
            ) : null}
          </dd>
          <dt>
            <span id="description">
              <Translate contentKey="crawlerBackendApp.productOfferingPrice.description">Description</Translate>
            </span>
          </dt>
          <dd>{productOfferingPriceEntity.description}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.productOfferingPrice.tariff">Tariff</Translate>
          </dt>
          <dd>
            {productOfferingPriceEntity.tariffs
              ? productOfferingPriceEntity.tariffs.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {productOfferingPriceEntity.tariffs && i === productOfferingPriceEntity.tariffs.length - 1
                      ? ''
                      : ', '}
                  </span>
                ))
              : null}
          </dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.productOfferingPrice.taxTariffTranche">
              Tax Tariff Tranche
            </Translate>
          </dt>
          <dd>
            {productOfferingPriceEntity.taxTariffTranches
              ? productOfferingPriceEntity.taxTariffTranches.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {productOfferingPriceEntity.taxTariffTranches &&
                    i === productOfferingPriceEntity.taxTariffTranches.length - 1
                      ? ''
                      : ', '}
                  </span>
                ))
              : null}
          </dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.productOfferingPrice.gridOperatorCapacity">
              Grid Operator Capacity
            </Translate>
          </dt>
          <dd>
            {productOfferingPriceEntity.gridOperatorCapacities
              ? productOfferingPriceEntity.gridOperatorCapacities.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {productOfferingPriceEntity.gridOperatorCapacities &&
                    i === productOfferingPriceEntity.gridOperatorCapacities.length - 1
                      ? ''
                      : ', '}
                  </span>
                ))
              : null}
          </dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.productOfferingPrice.productOffering">Product Offering</Translate>
          </dt>
          <dd>{productOfferingPriceEntity.productOffering ? productOfferingPriceEntity.productOffering.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/product-offering-price" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/product-offering-price/${productOfferingPriceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProductOfferingPriceDetail;
